import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

export const BreadcrumbBack = ({ children, ...props }) => {
    return (
        <Link {...props} className="breadcrumb-back">
            <FiArrowLeft />
            {children}
        </Link>
    );
};

export default BreadcrumbBack;
